"use client";

import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function Testimonials({ lang = 'vn' }: { lang?: 'vn' | 'en' }) {
  const slides = [
    {
      name: "Brian Cavanaugh",
      title: "CEO, VigilanteX",
      quote: lang === 'vn' ? "Với việc xây dựng cướp đi sinh mạng của gần 1.000 người mỗi năm, KeenEye mang lại sự rõ ràng tương tự cho công trường xây dựng và cơ sở hạ tầng quan trọng — cung cấp sự giám sát liên tục bằng AI và quản lý dự án ảo. Chúng tôi đang vận hành an toàn để bảo vệ tính mạng, nâng cao hiệu quả và thúc đẩy năng suất trên mọi công trường." : "With construction claiming nearly 1,000 lives annually, KeenEye brings that same clarity to construction and critical infrastructure — delivering continuous AI-driven oversight and virtual project management. We're operationalizing safety to protect lives, enhance efficiency, and significantly boost productivity on every job site.",
      image: "https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9affa_Brian%20VGX.avif"
    },
    {
      name: "Nguyen Minh Tuan",
      title: "General Manager, Minh Tuan Agri Farms (Đồng Nai)",
      quote: lang === 'vn' ? "Với OmniEdge AI, chúng tôi đã ngăn chặn được một đợt bùng phát dịch bệnh gia súc tàn khốc bằng cách phát hiện những thay đổi nhỏ về tư thế và chuyển động của lợn 3 ngày trước khi bất kỳ triệu chứng rõ ràng nào xuất hiện. Nó hoàn toàn bảo vệ khoản đầu tư của chúng tôi. Một bước ngoặt tuyệt đối cho nông nghiệp thông minh." : "With OmniEdge AI, we prevented a devastating livestock disease outbreak by detecting subtle posture and movement changes in our pigs 3 days before any visible symptoms appeared. It completely safeguarded our investments. Absolute game-changer for smart farming.",
      image: "https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&w=280&h=280&q=80"
    },
    {
      name: "Luke Misgen",
      title: "Chief Technology Officer, zTrip",
      quote: lang === 'vn' ? "Từ việc ngăn chặn trộm cắp đến việc tránh phá hoại, khả năng hiểu và phản hồi các mối đe dọa của hệ thống đã thay đổi hoàn toàn hoạt động an ninh của chúng tôi. Chúng tôi có thể giảm thiệt hại tài sản trong khi giữ an toàn hơn cho tài xế và nhân viên." : "From deterring theft to preventing vandalism, the system's ability to understand and respond to threats has transformed our security operations. We're able to reduce property damage while keeping our drivers and staff safer, all without the complexity and cost of traditional security solutions.",
      image: "https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9b019_Luke%20zTrip%20headshot%201.avif"
    },
    {
      name: "Brock Harlow",
      title: "CIO, Allied Stone",
      quote: lang === 'vn' ? "ROI rất rõ ràng — cải thiện hiệu quả, ngăn ngừa thương tích và mang lại những ý tưởng mới mà chúng tôi thậm chí chưa từng cân nhắc. AI cho phép chúng tôi tập trung vào việc diễn giải dữ liệu có giá trị." : "The ROI is clear — improving efficiency, preventing injuries, and bringing new ideas to the table we hadn’t even considered. AI lets us focus on interpreting valuable data, not just finding it, and pushes us to think bigger about what’s possible.",
      image: "https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9affe_Brock%20-%20Allied%20Stone.avif"
    },
    {
      name: "Kelsey Blackmon",
      title: "VP of Marketing & Technology, Blackmon Oil Co.",
      quote: lang === 'vn' ? "KeenEye giống như có một giám đốc vận hành AI. Đó là con mắt thứ ba của chúng tôi, thu thập dữ liệu, phân tích nó và cung cấp thông tin chi tiết để chúng tôi có thể hành động nhanh chóng." : "KeenEye is like having an AI operations manager. It’s our extra eye in the sky, collecting data, analyzing it, and delivering insights so we can act quickly.",
      image: "https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/68a898bdad65e34dfeb9b013_Kelsey%20-%20Blackmon%20Oil%20(1).avif"
    }
  ];

  return (
    <>
      <div className="section-reviews">
       <h2 className="outcome_heading-2 assitance-head">
        {lang === 'vn' ? 'Thành công nối tiếp' : 'Shift After Shift,'}
        <br/>
        {lang === 'vn' ? 'Thành công' : 'the Wins Stack Up'}
       </h2>
       
       <div className="swrper_component margin-bottom-none" style={{ position: 'relative', maxWidth: '1200px', margin: '0 auto' }}>
         <Swiper
           modules={[Navigation, Pagination, Autoplay]}
           spaceBetween={30}
           slidesPerView={1}
           navigation={{
             nextEl: '.swiper-button-next-custom',
             prevEl: '.swiper-button-prev-custom',
           }}
           pagination={{ clickable: true }}
           loop={true}
           autoplay={{
             delay: 6000,
             disableOnInteraction: false,
           }}
         >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>
                 <div className="slide-wrapper home-wrapper-slider" style={{ 
                   display: 'flex', 
                   flexDirection: 'row', 
                   width: '100%', 
                   maxWidth: '1050px', 
                   marginLeft: 'auto', 
                   marginRight: 'auto', 
                   alignItems: 'center', 
                   justifyContent: 'center', 
                   gap: '48px', 
                   padding: '24px 40px' 
                 }}>
                  <div className="slider_img-wrapper home-img-wrapper" style={{ 
                    flex: '0 0 35%', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    position: 'relative' 
                  }}>
                   <img alt={slide.name} className="slider_img home-slide-img" loading="lazy" src={slide.image} style={{ 
                     width: '280px', 
                     height: '280px', 
                     objectFit: 'cover', 
                     borderRadius: '50%', 
                     border: '4px solid rgba(255, 255, 255, 0.08)', 
                     boxShadow: '0 12px 40px rgba(99, 102, 241, 0.25), 0 2px 8px rgba(0, 0, 0, 0.4)' 
                   }} />
                  </div>
                  <div style={{ 
                    flex: '0 0 60%', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    position: 'relative', 
                    textAlign: 'left'
                  }}>
                     {/* The Quote Bubble */}
                     <div style={{
                       position: 'relative',
                       backgroundColor: '#1f222e',
                       border: '1px solid rgba(255, 255, 255, 0.1)',
                       borderRadius: '16px 16px 16px 0px',
                       padding: '32px 40px',
                       boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                       marginBottom: '16px'
                     }}>
                       {/* Glowing Quotation Background Icon */}
                       <svg style={{ 
                         position: 'absolute', 
                         top: '16px', 
                         left: '16px', 
                         width: '48px', 
                         height: '48px', 
                         fill: 'rgba(255, 255, 255, 0.04)', 
                         pointerEvents: 'none' 
                       }} viewBox="0 0 24 24">
                         <path d="M14 17h3l2-5V7h-6v5h3l-2 5zm-9 0h3l2-5V7H4v5h3l-2 5z" />
                       </svg>
                       <blockquote style={{ 
                         fontSize: '1.25rem', 
                         fontWeight: '400', 
                         fontStyle: 'italic',
                         lineHeight: '1.65', 
                         color: '#e2e8f0', 
                         margin: '0', 
                         letterSpacing: '-0.2px', 
                         fontFamily: 'Inter, system-ui, sans-serif',
                         position: 'relative',
                         zIndex: 1
                       }}>
                        "{slide.quote}"
                       </blockquote>
                     </div>
                     
                     {/* The Author Block */}
                     <div style={{ 
                       display: 'flex', 
                       flexDirection: 'column', 
                       borderLeft: '3px solid #6366f1', 
                       paddingLeft: '16px',
                       marginLeft: '0'
                     }}>
                      <span style={{ 
                        fontSize: '1.15rem', 
                        fontWeight: '600', 
                        color: '#ffffff', 
                        fontFamily: 'Inter, system-ui, sans-serif' 
                      }}>
                       {slide.name}
                      </span>
                      <span style={{ 
                        fontSize: '0.95rem', 
                        fontWeight: '400', 
                        color: 'rgba(255, 255, 255, 0.65)', 
                        marginTop: '4px', 
                        fontFamily: 'Inter, system-ui, sans-serif' 
                      }}>
                       {slide.title}
                      </span>
                     </div>
                  </div>
                 </div>
              </SwiperSlide>
            ))}
         </Swiper>
         
         <div className="swiper-button-next-custom" style={{ position: 'absolute', right: '0', top: '50%', transform: 'translateY(-50%)', zIndex: 10, cursor: 'pointer' }}>
          <img alt="" loading="lazy" src="https://cdn.prod.website-files.com/67752c25d40a7d652667c6cb/67763f6a30df14b9f205fbd2_iconamoon_arrow-up-2-light%20(1).svg"/>
         </div>
         <div className="swiper-button-prev-custom" style={{ position: 'absolute', left: '0', top: '50%', transform: 'translateY(-50%)', zIndex: 10, cursor: 'pointer' }}>
          <img alt="" loading="lazy" src="https://cdn.prod.website-files.com/67752c25d40a7d652667c6cb/67763fdbd9bde47f0bf7bc65_iconamoon_arrow-up-2-light%20(3).svg"/>
         </div>

         <div className="w-embed">
          <style dangerouslySetInnerHTML={{__html: `
            .swiper-slide {
              max-width: 100% !important;
              width: 100% !important;
            }

            /* Custom Premium Navigation Buttons */
            .swiper-button-next-custom, .swiper-button-prev-custom {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 48px;
              height: 48px;
              background-color: rgba(22, 20, 58, 0.6) !important;
              backdrop-filter: blur(10px);
              border: 1px solid rgba(255, 255, 255, 0.15) !important;
              border-radius: 50% !important;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
              box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4) !important;
            }

            .swiper-button-next-custom:hover, .swiper-button-prev-custom:hover {
              background-color: rgba(99, 102, 241, 0.4) !important;
              border-color: rgba(99, 102, 241, 0.8) !important;
              box-shadow: 0 0 20px rgba(99, 102, 241, 0.5) !important;
              transform: translateY(-50%) scale(1.08) !important;
            }

            .swiper-button-next-custom img, .swiper-button-prev-custom img {
              width: 20px;
              height: 20px;
              transition: transform 0.2s ease;
            }
            .swiper-button-next-custom:hover img {
              transform: translateX(2px);
            }
            .swiper-button-prev-custom:hover img {
              transform: translateX(-2px);
            }

           /* Swiper Pagination Dots Styling */
                        .swiper-pagination {
                          position: relative;
                          bottom: 0;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          gap: 6px;
                          margin-top: 40px;
                        }

                        .swiper-pagination-bullet {
                          width: 8px;
                          height: 8px;
                          background-color: #2b2d53; /* dark purple/blue */
                          border-radius: 999px;
                          opacity: 1;
                          transition: all 0.3s ease;
                        }

                        .swiper-pagination-bullet-active {
                          width: 24px; /* longer for pill look */
                          height: 8px;
                          background-color: #fff; /* white */
                        }

                         @media screen and (max-width: 991px) {
                           .slide-wrapper {
                             flex-direction: column !important;
                             text-align: center;
                             gap: 24px !important;
                             padding: 24px 20px !important;
                           }
                           .slider_img-wrapper {
                             justify-content: center !important;
                             padding-right: 0 !important;
                             margin-bottom: 12px;
                             flex: 1 1 100% !important;
                           }
                           .home-slide-content {
                             flex: 1 1 100% !important;
                             text-align: center !important;
                             padding: 0 !important;
                           }
                           .home-slide-content blockquote {
                             font-size: 1.15rem !important;
                           }
                           .home-slide-content div {
                             border-left: none !important;
                             padding-left: 0 !important;
                             align-items: center !important;
                           }
                         }
          `}} />
         </div>
       </div>
      </div>
    </>
  );
}
